import {
  faArrowsH,
  faBars,
  faCutlery,
  faFlask,
  faParking,
  faSnowflake,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useState } from 'react';
import './ArrivalLine.scss';
import Modal from '../../../../common/Modal/Modal';
import ChangeTimeModal from '../ChangeTimeModal/ChangeTimeModal';

// ArrivalLine Screen
const ArrivalLine = ({ movement, category, movementType, getMovements, hubId }) => {
  const [modalOpen, setModalOpen] = useState();

  const expectedAssignments = movement?.assignments?.filter(assignment => {
    if (
      movementType == 'exports' ||
      movementType == 'deliveries' ||
      movementType == 'subcontracts_out'
    )
      return assignment.originHubId == hubId;
    else return assignment.destinationHubId == hubId;
  });

  const getModalTitle = () => {
    switch (modalOpen) {
      case 'estimated':
        return `Expected Time - ${
          category == 'domestic' || category == 'subcontracted'
            ? `${expectedAssignments[0]?.job?.jobReference}`
            : `${movement?.reference || 'No Groupage'}`
        }`;
      case 'actual':
        return `Actual Time - ${
          category == 'domestic' || category == 'subcontracted'
            ? `${expectedAssignments[0]?.job?.jobReference}`
            : `${movement?.reference || 'No Groupage'}`
        }`;
    }
  };

  const getModalType = () => {
    return (
      <ChangeTimeModal
        setModalOpen={setModalOpen}
        modalType={modalOpen}
        movement={movement}
        movementType={movementType}
        category={category}
        getMovements={getMovements}
      />
    );
  };

  const hazard = expectedAssignments?.some(assignment => assignment?.job?.cargoHazardous);
  const doNotStack = expectedAssignments?.some(assignment => assignment?.job?.doNotStack);
  const waste = expectedAssignments?.some(assignment => assignment?.job?.commodityCategory?.waste);
  const foodstuffs = expectedAssignments?.some(
    assignment => assignment?.job?.commodityCategory?.foodstuffs,
  );
  const temperature = expectedAssignments?.some(
    assignment => assignment?.job?.temperatureControlled,
  );
  const overlength = expectedAssignments?.some(assignment => assignment?.job?.overlength);
  const prioritise = movement?.prioritise;
  const mustLoad = expectedAssignments?.some(assignment => assignment?.job?.mustLoad);

  return (
    <>
      <div className={`arrival_line_container ${movement.prioritise ? 'prioritise' : ''}`}>
        <div className="arrival_details">
          <div className="arrival_names">
            {category == 'domestic' || category == 'subcontracted' ? (
              <div className="job_ref">{expectedAssignments[0]?.job?.jobReference}</div>
            ) : (
              <div className="groupage_ref">{movement?.reference || 'No Groupage'}</div>
            )}
            <div className="supplier_name">{movement?.supplier?.name}</div>
            <div className="driver_name">
              {movement?.driver?.firstName || ''} {movement?.driver?.lastName || ''}
            </div>
          </div>
          <div className="arrival_job_details">
            <div className="trailer_type">Type: {movement?.trailerType?.name || 'Unknown'}</div>
            <div className="trailer_ref">Trailer: {movement?.trailerNumbers[0] || 'N/A'} </div>
            <div className="unit_number">Unit: {movement?.vehicleRegistration || 'N/A'}</div>
          </div>
          <div className="arrival_job_values">
            {category == 'domestic' || category == 'subcontracted' ? (
              <div className="groupage_ref">{movement?.reference}</div>
            ) : (
              <div className="num_jobs_packages">
                <div className="num_jobs">
                  {expectedAssignments?.length} job
                  {expectedAssignments?.length > 1 ? 's' : ''}
                </div>
                <div className="num_packages">
                  {expectedAssignments?.map(a => a?.quantity).reduce((a, b) => a + b, 0)} pkg
                </div>
              </div>
            )}
            <div className="gross_weight">
              {expectedAssignments?.map(a => a?.grossWeightKg).reduce((a, b) => a + b, 0)} kg
            </div>
            <div className="cubic_metres">
              {expectedAssignments
                ?.map(pkg => Number(pkg?.cubicMetres))
                .reduce((a, b) => a + b, 0)
                .toFixed(2)}
              m³
            </div>
          </div>
          <div className="arrival_symbol_row">
            {prioritise && (
              <div className="arrival_symbol prioritise">
                <FontAwesomeIcon icon={faParking} data-testid="priority_icon" />
              </div>
            )}
            {hazard && (
              <div className="arrival_symbol hazardous">
                <FontAwesomeIcon icon={faFlask} data-testid="hazard_icon" />
              </div>
            )}
            {doNotStack && (
              <div className="arrival_symbol do_not_stack">
                <FontAwesomeIcon icon={faBars} data-testid="do_not_stack_icon" />
              </div>
            )}
            {mustLoad && (
              <div className="arrival_symbol mustLoad">
                <FontAwesomeIcon icon={faParking} data-testid="must_load_icon" />
              </div>
            )}
            {waste && (
              <div className="arrival_symbol waste">
                <FontAwesomeIcon icon={faTrash} data-testid="waste_icon" />
              </div>
            )}
            {foodstuffs && (
              <div className="arrival_symbol foodstuffs">
                <FontAwesomeIcon icon={faCutlery} data-testid="foodstuffs_icon" />
              </div>
            )}
            {temperature && (
              <div className="arrival_symbol temp_control">
                <FontAwesomeIcon icon={faSnowflake} data-testid="temperature_icon" />
              </div>
            )}
            {overlength && (
              <div className="arrival_symbol overlength">
                <FontAwesomeIcon icon={faArrowsH} data-testid="overlength_icon" />
              </div>
            )}
          </div>
        </div>
        <div className="expected_actual_times">
          <button
            data-testid="expected_time_button"
            className={`arrival_expected_time ${prioritise ? 'prioritise' : ''} ${
              movement?.actualArrivalTime ? 'arrived' : ''
            }`}
            onClick={() => setModalOpen('estimated')}
          >
            <div>DUE</div>
            <div className="time">{movement?.currentExpectedArrivalHour || '--'}</div>
            <div className="date">
              {movement?.currentExpectedArrivalDate
                ? new Date(movement?.currentExpectedArrivalDate).toLocaleDateString()
                : '--'}
            </div>
          </button>
          <button
            data-testid="actual_time_button"
            className={`arrival_actual_time ${movement?.actualArrivalTime ? 'arrived' : ''}`}
            onClick={() => setModalOpen('actual')}
          >
            <div>ARRIVED</div>
            <div className="time">
              {movement?.actualArrivalTime
                ? `${movement?.actualArrivalTime?.split('T')[1]?.split(':')[0]}:${
                    movement?.actualArrivalTime?.split('T')[1]?.split(':')[1]
                  }`
                : '--'}
            </div>
            <div className="date">
              {movement?.actualArrivalTime
                ? new Date(movement?.actualArrivalTime?.split('T')[0]).toLocaleDateString()
                : '--'}
            </div>
          </button>
        </div>
      </div>
      {modalOpen && (
        <Modal title={getModalTitle()} content={getModalType()} setModalOpen={setModalOpen} />
      )}
    </>
  );
};

ArrivalLine.propTypes = {
  movement: PropTypes.object,
  category: PropTypes.string,
  movementType: PropTypes.string,
  getMovements: PropTypes.func,
  hubId: PropTypes.number,
};

export default ArrivalLine;
